.stateCell {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 0.25rem;
}

.oaUsage {
	display: flex;
	flex-direction: row;
	align-items: baseline;
	gap: 0.25rem;
	white-space: nowrap;
}

.oaUsageLabel {
	font-size: 0.68rem;
	color: #6b7280;
	line-height: 1.2;
}

.oaUsageValue {
	font-size: 0.85rem;
	font-weight: 700;
	line-height: 1.2;
	font-variant-numeric: tabular-nums;
}

.oaUsageValueComplete {
	color: #16a34a;
}
